import React from "react";

import {
	LabelPosition,
	RHookFormNumberField,
	// RHookFormNumberField,
	RHookFormNumberFieldWithLabel,
	RHookFormTextField,
} from "@websential/cosmic-v20";
import { Grid } from "@mui/material";

export interface IBillingSlabsInput {
	id: string;
	label: string;
	defaultValue?: string | number;
	readOnly?: boolean;
	numberField?: boolean;
}

export const BillingSlabsInput: React.FC<IBillingSlabsInput> = ({
	id,
	label,
	defaultValue = 0,
	readOnly = false,
	numberField = true,
}) => {
	return (
		<Grid container columnSpacing={1}>
			<Grid
				size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
				sx={{
					color: "rgba(0, 0, 0, 0.6)",
					fontSize: ".875rem",
					fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
					paddingTop: "5px",
				}}
			>
				{label}
			</Grid>
			<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
				{numberField ? (
					<RHookFormNumberField
						id={`${id}1`}
						testId={`${id}1`}
						// defaultValue={defaultValue}
						readOnly={readOnly}
					/>
				) : (
					<RHookFormTextField
						id={`${id}1`}
						testId={`${id}1`}
						defaultValue={defaultValue}
						readOnly={readOnly}
            
					/>
				)}
			</Grid>
			<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
				{numberField ? (
					<RHookFormNumberField id={`${id}2`} testId={`${id}2`} />
				) : (
					<RHookFormTextField id={`${id}2`} testId={`${id}2`} />
				)}
			</Grid>
			<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
				{numberField ? (
					<RHookFormNumberField id={`${id}3`} testId={`${id}3`} />
				) : (
					<RHookFormTextField id={`${id}3`} testId={`${id}3`} />
				)}
			</Grid>
			{/* <Grid item xs={2}> */}
			<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
				{numberField ? (
					<RHookFormNumberField id={`${id}4`} testId={`${id}4`} />
				) : (
					<RHookFormTextField id={`${id}4`} testId={`${id}4`} />
				)}
			</Grid>
			<Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
				{numberField ? (
					<RHookFormNumberField id={`${id}5`} testId={`${id}5`} />
				) : (
					<RHookFormTextField id={`${id}5`} testId={`${id}5`} />
				)}
			</Grid>
		</Grid>
	);
};
